import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import "./Room.css";
import ScrollToTop from "react-scroll-to-top";




import vinodini from "../images/vinidini_room.jpg";
import Superdeluxeroom from "../images/Super Deluxe room Berhampore.jpg";
import Superdeluxe from "../images/SupernDeluxeRoom.jpg";
import Vanyaroomnew from "../images/Vanya 104.jpg";
import VANYAHALL from "../images/hall.jpg";


import Vanyaroommain from "../images/Vanya 104.jpg";
import vanyaroomkk from "../images/bath_room.jpg"


function Vanya104() {

  return (
    <div>
      <Navbar />
      <br />
      <br />

      <br />
      <br />
   
      <br />

      <ScrollToTop smooth top="100" color="darkgoldenrod" />
      <div className='vinodini'>
        <div className="album py-2">
          <div className="container mt-2">
            <h3 className='mb-0' style={{ color: "maroon" }}>Super Deluxe Room <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
              <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
            </svg> Vanya 104</h3>
            <hr className='mb-1' style={{ color: "maroon" }} />
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/Super-deluxe-room" style={{ color: "maroon" }} >Back</Link></li>
                <li style={{ color: "maroon" }} className="breadcrumb-item active" aria-current="page">Vanya 104</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <br />
      <center>
        <div className='fonts'>
          <div className='album py-0'>
            <div className='container'>
              <div className='veva'>
                <h1><b>RESERVATION FOR LUXURY ROOM</b></h1>
              </div>
            </div>
          </div>
        </div>
      </center>

      <div className='album py-3'>
        <div className='container'>

          <div className="card mb-3" >
            <div className="row g-0">
              <div className="col-md-4">
              <img src={Vanyaroommain} className="img-fluid rounded-start" alt="Best Super Deluxe Room Berhampore"/>
              </div>
              <div className="col-md-8">
                <div className="card-body">
                  <div className='veva101'>
                    <h4 className="card-titl mb-1"><b>VANYA 104 <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                    </svg></b></h4>
                  </div>
                  <p className="card-text mb-1">Category - Ac Room,  Best Luxury Clean AC Room in Berhampore at Chaltia </p>
                  <a href='https://g.co/kgs/bGYUqH7' target="_blank" rel="noopener noreferrer">
                    <button className='direction mb-2'><small>View Direction <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-sign-merge-left" viewBox="0 0 16 16">
                      <path d="M7.25 6v1q-.211.451-.588.95c-.537.716-1.259 1.44-2.016 2.196l.708.708.015-.016c.652-.652 1.33-1.33 1.881-2.015V12h1.5V6h1.216a.25.25 0 0 0 .192-.41L8.192 3.23a.25.25 0 0 0-.384 0L5.842 5.59a.25.25 0 0 0 .192.41z" />
                      <path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z" />
                    </svg></small></button>
                  </a>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <p className="card-text mb-2"><small className="text-muted"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
                      <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0" />
                      <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708" />
                    </svg> Check in - 12:00 PM </small></p>
                    <p className="card-text mb-2"><small className="text-muted"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
                      <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0" />
                      <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708" />
                    </svg> Check out - 10:00 AM </small></p>
                  </div>
                  <h5 className='mb-1'>Room Tariff: - <b>3500</b> + GST</h5>




                  <a href='tel: 9046258703'>
                    <button className="button10 button11 mt-1">Call Now</button>
                  </a>













                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='album py-0'>
        <div className='container'>
          <div className="row">
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={vanyaroomkk} className="card-img-top image2" alt="vanyaroom"/>
                  <div className="overlay1"> VANYA 104</div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={Superdeluxeroom} className="card-img-top image2" alt="Superdeluxeroom"/>
                  <div className="overlay1"> VANYA 104</div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={Superdeluxe} className="card-img-top image2" alt="vinodini_room" />
                  <div className="overlay1"> VANYA 104</div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={Vanyaroomnew} className="card-img-top image2" alt="Vanyaroomnew"/>
                  <div className="overlay1"> VANYA 104</div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={vinodini} className="card-img-top image2" alt="vinodini_room" />
                  <div className="overlay1"> VANYA 104</div>
                </div>
              </div>
            </div>

            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={VANYAHALL} className="card-img-top image2" alt="VANYAHALL"/>
                  <div className="overlay1"> VANYA 104</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


      {/* <Facility/> */}
      <br />
    </div>
  )
}

export default Vanya104